// extracted by mini-css-extract-plugin
module.exports = {"content":"page-module--content--2ZYAF","img":"page-module--img--3OJZu"};